import { useEffect, useState } from 'react';
import { api, type DoorEpisode } from '../lib/api';

type Key = 'publishedAt' | 'plays' | 'playsWeek' | 'likes' | 'comments' | 'saved';

// On the door (T211): every published episode as rookeryos.com sees it, in
// one table the creator can sort — and, per row, the director's one move.
export function DoorEpisodes({ onOpen }: { onOpen: (cardId: string) => void }) {
  const [eps, setEps] = useState<DoorEpisode[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [key, setKey] = useState<Key>('publishedAt');
  useEffect(() => { api.doorEpisodes().then(setEps).catch((e: Error) => setError(e.message)); }, []);
  if (error) return <div className="err inline">{error}</div>;
  if (!eps || eps.length === 0) return null;
  const sorted = [...eps].sort((a, b) => key === 'publishedAt' ? (b.publishedAt ?? '').localeCompare(a.publishedAt ?? '') : b[key] - a[key]);
  const move = (e: DoorEpisode) => e.unanswered > 0 ? `answer ${e.unanswered} comment${e.unanswered === 1 ? '' : 's'}` : !e.indexed ? 'indexing on the next run' : e.takeaways === 0 ? 'no takeaways yet — rebuild the index' : e.playsWeek === 0 && e.plays > 0 ? 'quiet this week — share it' : '';
  const Th = ({ k, children }: { k: Key; children: React.ReactNode }) => <th style={{ cursor: 'pointer', textDecoration: key === k ? 'underline' : undefined }} onClick={() => setKey(k)} title="Sort by this">{children}</th>;
  return (
    <section data-tool="door-episodes" style={{ marginTop: 16 }}>
      <h3>On the door</h3>
      <p className="sub-dim">Every published episode as rookeryos.com sees it. Click a heading to sort; click a title to open the card.</p>
      <div style={{ overflowX: 'auto' }}>
        <table className="pubs" style={{ width: '100%' }}>
          <thead><tr><th>Episode</th><Th k="publishedAt">Published</Th><Th k="plays">Plays</Th><Th k="playsWeek">7 days</Th><Th k="likes">Likes</Th><Th k="comments">Comments</Th><Th k="saved">Saved</Th><th>The move</th></tr></thead>
          <tbody>
            {sorted.map((e) => (
              <tr key={e.id}>
                <td><button type="button" className="linklike" onClick={() => onOpen(e.id)}>{e.title}</button>
                  {e.series && <span className="sub-dim"> · {e.series.name}{e.series.part ? ` · part ${e.series.part}` : ''}</span>}
                  {e.visibility !== 'public' && <span className="chip" style={{ marginLeft: 6 }}>{e.visibility === 'members' ? 'members only' : 'unlisted'}</span>}</td>
                <td className="sub-dim">{e.publishedAt ? new Date(e.publishedAt).toLocaleDateString() : ''}</td>
                <td>{e.plays.toLocaleString()}</td><td>{e.playsWeek.toLocaleString()}</td><td>{e.likes.toLocaleString()}</td>
                <td>{e.comments.toLocaleString()}{e.unanswered > 0 && <span className="chip" style={{ marginLeft: 4 }}>{e.unanswered} unanswered</span>}</td>
                <td>{e.saved.toLocaleString()}</td>
                <td className="sub-dim">{move(e)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
